import { FormatDate } from "../../../helper";

// Status to Tailwind color class mapping
const STATUS_COLOR_MAP = {
  approved: "text-[#4ab932]", // Green
  pending: "text-amber-500",  // Yellow
  initiated: "text-blue-500", // Blue
  rejected: "text-red-500",   // Red
  cancelled: "text-red-500",   // Red
};

const TransactionListItem = ({
  transaction,
  isSelected,
  onSelect,
  isMobile = false,
}) => {
  const type = transaction.transaction_type?.toLowerCase() || "";
  const nature = transaction.transaction_nature?.toLowerCase() || "";
  const isCredit = type === "credit";

  // Container styling
  const containerClass = isMobile
    ? "bg-background-alt px-3 active:bg-option-hover"
    : isSelected
      ? "bg-[rgba(74,185,50,0.08)] px-2 hover:bg-[rgba(74,185,50,0.08)]"
      : "bg-background-alt px-2 hover:bg-option-hover";

  // Helper to resolve title/description
  const getDisplayTitle = () => {
    if (transaction.remarks && transaction.remarks.trim().length > 0) {
      return transaction.remarks;
    }
    return transaction.account_title || `Transaction #${transaction.transaction_id}`;
  };

  // Format secondary/counter amount string based on nature
  const getSecondaryAmountText = () => {
    if (!transaction.crypto_amount || !transaction.currency_code) {
      return null;
    }

    let secondarySign = "";

    if (nature === "buy") {
      // In a Buy order: Credit receives asset (+), Debit pays counter currency (-)
      secondarySign = isCredit ? "-" : "+";
    } else if (nature === "sell") {
      // In a Sell order: Credit receives counter currency (+), Debit gives asset (-)
      secondarySign = isCredit ? "-" : "+";
    } else if (nature === "swap") {
      // In a Swap: Opposite directional sign of primary
      secondarySign = isCredit ? "-" : "+";
    } else {
      // Fallback for transfer/withdrawal/deposit
      secondarySign = isCredit ? "-" : "+";
    }

    return `${secondarySign} ${transaction.crypto_amount} ${transaction.currency_code}`;
  };

  const secondaryText = getSecondaryAmountText();

  // Format primary amount string
  const primarySign = isCredit ? "+" : "-";
  const primaryAmount = `${primarySign} ${transaction.amount} ${transaction.crypto_currency_code}`;
  const primaryColorClass = isCredit ? "text-[#4ab932]" : "text-error-500";

  // Resolve status color
  const normalizedStatus = transaction.status?.toLowerCase() || "";
  const statusColorClass = STATUS_COLOR_MAP[normalizedStatus] || "text-text-secondary";

  // const networkLogo = transaction?.asset?.logo_url;
  // const assetName = asset.currency_short || asset.network.name || "AS";
  // const assetSymbol = asset.name || asset.currency_name || "AS";
  // const networkCode = asset.network?.code || "NW";

  return (
    <button
      type="button"
      onClick={() => onSelect(transaction)}
      className={`flex w-full flex-col rounded-[12px] py-[15px] text-left custom-transition ${containerClass}`}
    >
      <div className="flex items-center justify-between gap-1">
        {/* Left Section: Logo & Account Details */}
        <div className="flex min-w-0 items-center gap-1">
          {/* <div className="flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-full bg-background-muted">
            <img
              src={transaction.logo}
              alt={transaction.crypto_currency_code || "crypto logo"}
              className="size-9 rounded-full object-cover"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div> */}

          <div className="relative shrink-0">
            <img
              src={transaction.logo}
              alt={transaction.crypto_currency_code || "crypto logo"}
              className="size-9 rounded-full object-cover"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />

            {transaction?.asset && (
              <img
                src={transaction?.asset?.logo_url}
                alt={transaction?.asset?.name}
                className="absolute -bottom-1 -right-0 h-4 w-4 rounded-full border-[1px] border-white bg-white object-contain"
              />
            )}
          </div>

          <div className="min-w-0">
            <p className="truncate text-sm font-semibold leading-[19.5px] text-text-primary">
              {getDisplayTitle()}
            </p>

            <div className="flex items-center gap-1 md:gap-1.5 text-xs text-text-secondary">
              <span>{FormatDate(transaction.transaction_date, "d m, yy")}</span>
              {transaction.transaction_nature && (
                <>
                  <span>•</span>
                  <span className="capitalize font-xs">{transaction.transaction_nature}</span>
                </>
              )}
              {transaction.status && (
                <>
                  <span>•</span>
                  <span className={`capitalize font-xs ${statusColorClass}`}>
                    {transaction.status}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>

        {/* Right Section: Amounts & Currency */}
        <div className="flex shrink-0 flex-col items-end gap-px">
          <p className={`whitespace-nowrap text-sm font-semibold leading-[19.5px] ${primaryColorClass}`}>
            {primaryAmount}
          </p>

          {secondaryText && (
            <p className="whitespace-nowrap text-xs font-normal leading-[16.5px] text-text-secondary">
              {secondaryText}
            </p>
          )}
        </div>
      </div>
    </button>
  );
};

export default TransactionListItem;